import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import TimePicker from '../../../../../../../../../../1stlog-ui/src/components/TimePicker'
import Field, { FieldPrefix } from '../../../../../../../../../../1stlog-ui/src/components/Field'

const Wrapper = styled.div``

const TimeWindow = (props) => {
  const {} = props

  return (
    <Wrapper>
      <div className="text-muted">
      {i18n.t(
          'delivery_pickup_timewindow_description',
          'Die Zustellung/Abholung kann auch vor dem angegebenen Zeitfenster/Tag erbracht werden. Ist dieser Versuch jedoch erfolglos, so muss im gebuchten Zeitfenster/Tag die Zustellung oder Abholung erneut ohne Zusatzkosten durchgeführt werden.')}
        <br />
      {i18n.t(
          'prices_are_calculated_in_two_hour_intervals',
          'Die Preisberechnung erfolgt in zwei-Stunden Intervallen.')}
      </div>
      <div className="mt-1">
        <FieldPrefix name="timeWindow">
          <div className="d-flex align-items-center">
            <Field name="start">
              <TimePicker />
            </Field>
            <div className="mx-2" style={{ marginBottom: '5px' }}>
              {i18n.t(`to`, `bis`)}
            </div>
            <Field name="end">
              <TimePicker />
            </Field>
          </div>
        </FieldPrefix>
      </div>
    </Wrapper>
  )
}

export default TimeWindow
